import { IApiQueryFunction, createApiQueryHook } from "../../utils/api";
import { RelationalValue, mapRelationalValue } from "../../utils/filters";
import { IUserResource, IUserSettings } from "../types";

export interface IUserSettingsQueryParameters {
    user?: RelationalValue<IUserResource>;
}

export type IUserSettingsQueryResult = IUserSettings;

export const userSettingsQuery: IApiQueryFunction<IUserSettingsQueryParameters> = ({ user }) => {
    if (!user) {
        return;
    }

    return {
        method: "GET",
        url: `/user_settings/${mapRelationalValue(user)}`,
    };
};

export const useUserSettingsQuery = createApiQueryHook<IUserSettingsQueryParameters, IUserSettingsQueryResult>(
    userSettingsQuery,
);
